import script from "./ProgressView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressView.vue?vue&type=script&setup=true&lang=js"

import "./ProgressView.vue?vue&type=style&index=0&id=bd5c4b28&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd5c4b28"]])

export default __exports__